export const GET_COMPETITORS_DATABASE_STRUCTURE_REQUEST =
  "GET_COMPETITORS_DATABASE_STRUCTURE_REQUEST";
export const GET_COMPETITORS_DATABASE_STRUCTURE_SUCCESS =
  "GET_COMPETITORS_DATABASE_STRUCTURE_SUCCESS";
export const GET_COMPETITORS_DATABASE_STRUCTURE_FAILURE =
  "GET_COMPETITORS_DATABASE_STRUCTURE_FAILURE";
